import { Modal, Icon, Text } from '@intellecteu/common-ui';
import { useEscapeKey } from 'app/utils';
import { InfoCardItem } from '../../ui';
import { CopyText } from '../../copy-text';

import s from '../validators/styles.module.scss';

interface PartyCreatedModalProps {
  fullPartyId: string;
  onSubmit: () => void;
  onClose: () => void;
}

export const PartyCreatedModal = ({ fullPartyId, onSubmit, onClose }: PartyCreatedModalProps) => {
  // Escape closes without copying: browsers block clipboard writes from an Escape keypress
  useEscapeKey(onClose);

  return (
    <Modal
      withConfirm
      className={s.copyModal}
      footerClassName={s.copyModalFooter}
      onSubmit={onSubmit}
      submitText="Copy and close"
      onClose={onSubmit}
      cancelText=""
    >
      <div className={s.copyModalContent}>
        <div className={s.copyModalContentHeader}>
          <Icon icon={Icon.icons.info} color="darkBlue" />
          <Text weight="bold">Party created</Text>
        </div>
        <InfoCardItem title="Party identifier" value={<CopyText value={fullPartyId} />} />
      </div>
    </Modal>
  );
};
